<template>
    <div class="row">
        <div class="col-12">
			<div class="mt-4" style="max-width: 480px">

				<div class="form-group row">
					<div class="col-12">
						<label>Name</label>
						<input type="text" placeholder="Site Name" v-model="name" class="form-control">
					</div>
				</div>

				<div class="form-group row">
					<div class="col-12">
						<label>Address Line 1</label>
						<input type="text" placeholder="Site Address" v-model="address_line_1" class="form-control">
					</div>
				</div>

				<div class="form-group row">
					<div class="col-12">
						<label>Address Line 2</label>
						<input type="text" placeholder="" v-model="address_line_2" class="form-control">
					</div>
				</div>

				<div class="form-group row">
					<div class="col-12">
						<label>City</label>
						<input type="text" placeholder="City" v-model="city" class="form-control">
					</div>
				</div>

				<div class="form-group row">
					<div class="col-12">
						<label>Postcode</label>
						<input type="text" placeholder="Postcode" v-model="postcode" class="form-control">
					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "EditSitePage",
		props: [
			'site',
			'back_url',
			'save_url'
        ],

        data(){
			return {
				id: null,
				name: '',
				address_line_1: '',
				address_line_2: '',
				city: '',
				postcode: '',

				saving: false,
                errors: []
            }
        },

		beforeMount() {
			this.id = this.site.id;
			this.name = this.site.name;
			this.address_line_1 = this.site.address_line_1;
			this.address_line_2 = this.site.address_line_2;
			this.city = this.site.city;
			this.postcode = this.site.postcode;

			window.addEventListener('LAYOUT:primary_button', this.save);
			window.addEventListener('LAYOUT:cancel_button', this.cancel);
		},

		methods: {
			save(){
                this.errors = [];

				if (this.saving) return false;

				this.saving = true;
				axios.patch(this.save_url, {
					id: this.id,
					name: this.name,
					address_line_1: this.address_line_1,
					address_line_2: this.address_line_2,
					city: this.city,
					postcode: this.postcode
				})
					.then(response => {
						this.saving = false;
						window.location.href = this.back_url;
					})
					.catch(error => {
						this.saving = false;

                        if (error.response.data.errors !== undefined) {
                            Object.values(error.response.data.errors).forEach((err, i) => {
                                this.errors.push(`<li>${err[0]}</li>`);
                            });
                        }

                        if (this.errors.length >= 2) {
                            Vue.$toast.open({
                                message: `There were ${this.errors.length} errors: ${this.errors.join('')}`,
                                type: 'error'
                            });
                        } else if (this.errors.length === 1) {
                            Vue.$toast.open({
                                message: `There was an error: ${this.errors.join('')}`,
                                type: 'error'
                            });
                        }
					});
			},
			cancel(){
				window.location.href = this.back_url;
			}
        }
	}
</script>
